module.exports = __webpack_public_path__ + "img/rang1.09b95ac3.png";